import { useState } from 'react';
import { Badge, Offcanvas } from 'react-bootstrap';
import { FaCog, FaShoppingCart, FaTags, FaUser } from 'react-icons/fa';
import { Link } from 'react-router-dom';

import CompanySelector from '../admin/CompanySelector';
import useBodyScrollLock from '../../hooks/useBodyScrollLock';

const HeaderMobileUserMenu = ({ userInfo, cartItemsCount, onLogout, onOpenChange }) => {
    const [isOpen, setIsOpen] = useState(false);

    useBodyScrollLock(isOpen);

    const openPanel = () => {
        setIsOpen(true);
        onOpenChange?.(true);
    };

    const closePanel = () => {
        setIsOpen(false);
        onOpenChange?.(false);
    };

    const handleLogout = async () => {
        closePanel();
        await onLogout?.();
    };

    return (
        <>
            <button
                type="button"
                className="header-user-trigger"
                onClick={openPanel}
                aria-label="Abrir menu de usuario"
            >
                <FaUser size={24} />
            </button>

            <Offcanvas
                show={isOpen}
                onHide={closePanel}
                placement="end"
                className="header-user-offcanvas"
                scroll
                restoreFocus={false}
            >
                <Offcanvas.Header closeButton className="header-user-offcanvas-header">
                    <Offcanvas.Title>Mi cuenta</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="header-user-offcanvas-body">
                    <div className="header-user-menu-list">
                        <Link to="/cart" className="header-user-menu-item" onClick={closePanel}>
                            <span className="d-inline-flex align-items-center gap-2">
                                <FaShoppingCart /> Carrito
                            </span>
                            {cartItemsCount > 0 && <Badge bg="danger">{cartItemsCount}</Badge>}
                        </Link>

                        <Link to="/discounts" className="header-user-menu-item" onClick={closePanel}>
                            <span className="d-inline-flex align-items-center gap-2">
                                <FaTags /> Descuentos
                            </span>
                        </Link>

                        {userInfo ? (
                            <>
                                <Link to="/profile" className="header-user-menu-item" onClick={closePanel}>
                                    <span className="d-inline-flex align-items-center gap-2">
                                        <FaUser /> Perfil
                                    </span>
                                </Link>
                                <Link to="/orders" className="header-user-menu-item" onClick={closePanel}>
                                    <span className="d-inline-flex align-items-center gap-2">
                                        <FaUser /> Mis pedidos
                                    </span>
                                </Link>
                                {userInfo?.isKiosk && (
                                    <Link to="/in-store-price-checker" className="header-user-menu-item" onClick={closePanel}>
                                        <span className="d-inline-flex align-items-center gap-2">
                                            <FaUser /> Verificador de precios en tienda
                                        </span>
                                    </Link>
                                )}
                                <button type="button" className="header-user-menu-item" onClick={handleLogout}>
                                    <span className="d-inline-flex align-items-center gap-2">
                                        <FaUser /> Cerrar sesion
                                    </span>
                                </button>

                                {userInfo.isAdmin && (
                                    <>
                                        <div className="header-user-menu-section-title">
                                            <FaCog /> Administracion
                                        </div>

                                        {userInfo.isSuperAdmin && (
                                            <div className="header-user-company-selector">
                                                <CompanySelector />
                                            </div>
                                        )}

                                        <Link to="/admin/productlist" className="header-user-menu-item" onClick={closePanel}>
                                            Productos
                                        </Link>
                                        <Link to="/admin/outofstock" className="header-user-menu-item" onClick={closePanel}>
                                            Out of Stock
                                        </Link>
                                        <Link to="/admin/categorylist" className="header-user-menu-item" onClick={closePanel}>
                                            Categorias
                                        </Link>
                                        <Link to="/admin/brandlist" className="header-user-menu-item" onClick={closePanel}>
                                            Marcas
                                        </Link>
                                        <Link to="/admin/userlist" className="header-user-menu-item" onClick={closePanel}>
                                            Usuarios
                                        </Link>
                                        <Link to="/admin/orderlist" className="header-user-menu-item" onClick={closePanel}>
                                            Pedidos
                                        </Link>
                                        <Link to="/admin/sales-report" className="header-user-menu-item" onClick={closePanel}>
                                            Reportes de ventas
                                        </Link>
                                        <Link to="/admin/discountlist" className="header-user-menu-item" onClick={closePanel}>
                                            Descuentos
                                        </Link>
                                        <Link to="/admin/eventlist" className="header-user-menu-item" onClick={closePanel}>
                                            Eventos y promociones
                                        </Link>

                                        {userInfo.isSuperAdmin && (
                                            <>
                                                <Link to="/admin/companylist" className="header-user-menu-item" onClick={closePanel}>
                                                    Empresas
                                                </Link>
                                                <Link to="/admin/partnerlist" className="header-user-menu-item" onClick={closePanel}>
                                                    Solicitudes partners
                                                </Link>
                                            </>
                                        )}
                                    </>
                                )}
                            </>
                        ) : (
                            <Link to="/login" className="header-user-menu-item" onClick={closePanel}>
                                <span className="d-inline-flex align-items-center gap-2">
                                    <FaUser /> Iniciar sesion
                                </span>
                            </Link>
                        )}
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default HeaderMobileUserMenu;
